// 地主前台金額格式 mixin：千分位、無小數、後綴貨幣單位「元」（設計稿樣式）
// 用於 LeftPanel / UnitDialog 等會顯示金額的元件；坪數等非金額欄位不套用。
export default {
  methods: {
    fmtMoney(v) {
      if (v == null) return '-';
      return this.fmtNum(v) + this.$t('URBANRENEWAL_SELECT.PANEL.CURRENCY_UNIT');
    },
    // 純數字（千分位、無小數、不帶單位）；供「單價（元/坪）：{v}元」這類自帶單位的整句使用
    fmtNum(v) {
      if (v == null) return '-';
      return Number(v).toLocaleString('zh-TW', { maximumFractionDigits: 0 });
    },
  },
};
